// extracted by mini-css-extract-plugin
module.exports = {"dot":"PreviewDot_dot__2pSrr","legend":"PreviewDot_legend__2Iasb"};